/* PricingCalculatorSection.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _9 = "._u5f3h461{padding-right:var(--ds-space-050)}";
const _8 = "._y3gn1h6o{text-align:center}";
const _7 = "._zulpl6l0{gap:var(--ds-space-300)}";
const _6 = "._2rko1crf{border-radius:9pt}";
const _5 = "._19it7v06{border:1px solid var(--ds-border)}";
const _4 = "._1u9k1h6o{justify-cntent:center}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Button from '@atlaskit/button/standard-button';
import ChevronLeftIcon from '@atlaskit/icon/utility/chevron-left';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import { useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { breakpointValues, LinkButton, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import { HostingDisplayName } from '@atlassian/mpac-types';
import { AtlassianProductHostingType as HostingType, MarketplaceBillingCycle as BillingCycle } from '@atlassian/mpac-types/graphql-gateway-types';
import React, { useState } from 'react';
import { TEST_ID } from '../../../../../../constants';
import { additionalPricingDetailsModalOpenedEvent } from '../../../../AnalyticsHelper';
import { VIEW_ADDITIONAL_PRICING_DETAILS } from '../PricingTab.constants';
import { AdditionalPricingSection, BackButton } from '../PricingTab.styles';
import PricingTable from '../PricingTiers/PricingTable';
import CloudPricingCalculator from './CloudPricingCalculator';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _3 = "._18s813hs{margin:var(--ds-space-400) auto}";
const _2 = "._zulphiv4{gap:var(--ds-space-400)}";
const _ = "._p12f1qz2{max-width:890px}";
const PricingCalculatorContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_p12f1qz2 _zulphiv4 _18s813hs", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingCalculatorContainer.displayName = 'PricingCalculatorContainer';
}
const PricingContainer = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _5, _6, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1u9k1h6o _19it7v06 _2rko1crf _zulpl6l0", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingContainer.displayName = 'PricingContainer';
}
const AdditionalPricingText = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_y3gn1h6o _u5f3h461", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AdditionalPricingText.displayName = 'AdditionalPricingText';
}
const PricingCalculatorSection = _ref4 => {
  let {
    monthlyPlan,
    annualPlan,
    onPricingCalculatorInstallCTAClick,
    compatibleProduct
  } = _ref4;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [billingCycle, setBillingCycle] = useState(BillingCycle.Monthly);
  const fireAnalyticsEvent = useAnalyticsEvents();
  const handleAdditionalPricingModalClose = () => setModalIsOpen(false);
  const handleAdditionalPricingModalOpen = () => {
    fireAnalyticsEvent(additionalPricingDetailsModalOpenedEvent(billingCycle));
    setModalIsOpen(true);
  };
  const handleBillingCycleToggle = togglePosition => {
    setBillingCycle(togglePosition);
  };
  const {
    tieredPricing: {
      items: annualItems,
      tierType: annualTierType
    },
    currency
  } = annualPlan;
  const {
    tieredPricing: {
      items: monthlyItems,
      tierType: monthlyTierType
    }
  } = monthlyPlan;
  const [items, tierType] = billingCycle === BillingCycle.Annual ? [annualItems, annualTierType] : [monthlyItems, monthlyTierType];
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.md;
  return /*#__PURE__*/_jsxs(PricingCalculatorContainer, {
    children: [/*#__PURE__*/_jsxs(PricingContainer, {
      children: [/*#__PURE__*/_jsx(CloudPricingCalculator, {
        pricingItems: items,
        currency: currency,
        billingCycle: billingCycle,
        onBillingCycleToggle: handleBillingCycleToggle,
        onPricingCalculatorInstallCTAClick: onPricingCalculatorInstallCTAClick,
        compatibleProduct: compatibleProduct
      }), /*#__PURE__*/_jsxs(AdditionalPricingSection, {
        children: [/*#__PURE__*/_jsx(AdditionalPricingText, {
          children: "Are you looking for team growth?"
        }), /*#__PURE__*/_jsx(LinkButton, {
          onClick: handleAdditionalPricingModalOpen,
          testId: TEST_ID.PRICING_TAB_VIEW_ADDITIONAL_PRICING,
          "aria-haspopup": "dialog",
          children: VIEW_ADDITIONAL_PRICING_DETAILS
        })]
      })]
    }), /*#__PURE__*/_jsx(ModalTransition, {
      children: modalIsOpen && /*#__PURE__*/_jsxs(Modal, {
        onClose: handleAdditionalPricingModalClose,
        width: "small",
        children: [isMobile && /*#__PURE__*/_jsxs(BackButton, {
          onClick: handleAdditionalPricingModalClose,
          children: [/*#__PURE__*/_jsx(ChevronLeftIcon, {
            label: "Back",
            LEGACY_size: "large"
          }), "Back"]
        }), /*#__PURE__*/_jsx(ModalHeader, {
          children: /*#__PURE__*/_jsx(ModalTitle, {
            children: "".concat(HostingDisplayName[HostingType.Cloud], " app pricing overview")
          })
        }), /*#__PURE__*/_jsx(ModalBody, {
          children: /*#__PURE__*/_jsx(PricingTable, {
            currency: currency,
            items: items,
            tierType: tierType,
            hosting: HostingType.Cloud,
            billingCycle: billingCycle
          })
        }), !isMobile && /*#__PURE__*/_jsx(ModalFooter, {
          children: /*#__PURE__*/_jsx(Button, {
            onClick: handleAdditionalPricingModalClose,
            children: "Close"
          })
        })]
      })
    })]
  });
};
export default PricingCalculatorSection;